import { useEffect, useState } from 'react'
import { Space, Typography, Tooltip, Spin } from 'antd'
import {
  ReloadOutlined,
  ClockCircleOutlined,
  PlusCircleOutlined
} from '@ant-design/icons'
import moment from 'moment'
import { getPayload } from '../../utils/auth'
import { useActiveWorklog } from '../registroHoras/hooks/useActiveWorklog'
import { getActiveWorklogSummary } from '../registroHoras/shared/activeWorklogSummary'

// Singleton: cualquier código puede llamar worklogBadge.refresh()
// sin importar en qué árbol React esté montado
export const worklogBadge = { refresh: () => {} }

interface WorklogStatusBadgeProps {
  onOpenModal: () => void
}

const ElapsedTimer: React.FC<{ startTime: string }> = ({ startTime }) => {
  const [elapsed, setElapsed] = useState('')

  useEffect(() => {
    const calc = () => {
      const diff = moment.duration(moment().diff(moment(startTime)))
      const h = Math.floor(diff.asHours())
      const m = diff.minutes()
      const s = diff.seconds()
      setElapsed(`${h}h ${m}m ${s}s`)
    }
    calc()
    const interval = setInterval(calc, 1000)
    return () => clearInterval(interval)
  }, [startTime])

  return (
    <Typography.Text strong style={{ fontSize: '0.85rem' }}>
      {elapsed}
    </Typography.Text>
  )
}

const WorklogStatusBadge: React.FC<WorklogStatusBadgeProps> = ({ onOpenModal }) => {
  const payload = getPayload()
  const { activeWorklog, loading, refresh } = useActiveWorklog(payload?.id)

  // Registra refresh en el singleton para que cualquier código externo pueda llamarlo
  worklogBadge.refresh = refresh

  const hasPending = activeWorklog != null && activeWorklog.end_time == null
  const summary = getActiveWorklogSummary(activeWorklog)

  return (
    <Space
      size={4}
      align='center'
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {loading ? (
        <Spin size='small' />
      ) : hasPending ? (
        <>
          <Tooltip title={summary.tooltip || 'Abrir actividad'}>
            <ClockCircleOutlined
              onClick={onOpenModal}
              style={{
                fontSize: '0.9rem',
                cursor: 'pointer',
                color: '#52c41a'
              }}
            />
          </Tooltip>
          <ElapsedTimer startTime={activeWorklog.start_time} />
        </>
      ) : (
        <Space
          size={4}
          align='center'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography.Text type='secondary' style={{ fontSize: '0.8rem' }}>
            Sin actividad
          </Typography.Text>
          <Tooltip title='Crear actividad'>
            <PlusCircleOutlined
              onClick={onOpenModal}
              style={{ fontSize: '0.9rem', cursor: 'pointer' }}
            />
          </Tooltip>
        </Space>
      )}
      <Tooltip title='Refrescar actividad' placement='bottom'>
        <ReloadOutlined
          onClick={refresh}
          style={{ fontSize: '0.75rem', cursor: 'pointer' }}
        />
      </Tooltip>
    </Space>
  )
}

export default WorklogStatusBadge
